import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import colors from 'containers/App/colors';
import get from 'lodash/get';
import { filter, isEmpty, merge, propEq } from 'ramda';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const getValue = (inputValue, options) => {
  const value = filter(propEq('value', inputValue))(options);

  return isEmpty(value) ? { value: inputValue, label: inputValue } : value;
};

const SelectField = ({
  block,
  className,
  clearable = true,
  components = {},
  creatable,
  disabled,
  id,
  input,
  isLoading = false,
  isOptionDisabled,
  meta: { touched, error },
  msg,
  name,
  noResultsText,
  onSelectBlur,
  onClose,
  onFocus,
  onInputChange,
  options,
  placeholder,
  styles = {},
  wrapperClassName = '',
}) => {
  const onChange = (args) => input.onChange(get(args, 'value', args));
  const handleBlur = () => null;
  const Component = creatable ? CreatableSelect : Select;

  return (
    <div
      className={classNames(block ? 'block' : 'inline-block', wrapperClassName)}
    >
      <div>
        <Component
          {...input}
          className={className}
          classNamePrefix='react-select'
          components={components}
          id={id}
          isClearable={clearable}
          isDisabled={disabled}
          isLoading={isLoading}
          isOptionDisabled={isOptionDisabled}
          name={name}
          noResultsText={noResultsText}
          onBlur={onSelectBlur || handleBlur}
          onChange={onChange}
          onClose={onClose}
          onFocus={onFocus}
          onInputChange={onInputChange}
          options={options}
          placeholder={placeholder}
          styles={
            touched && error
              ? merge(styles, {
                  control: (base) => ({ ...base, borderColor: colors.danger }),
                })
              : styles
          }
          value={getValue(input.value, options)}
        />
      </div>
      {touched && error && (
        <FormErrorMessage>
          {get(msg, ['validation', error], 'Error')}
        </FormErrorMessage>
      )}
    </div>
  );
};

export default SelectField;
